var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Lager","visible":_vm.show},on:{"close":function($event){return _vm.$emit('close')}}},[_c('product-variations-warehouses',{attrs:{"product-variations-warehouses":_vm.productVariationsWarehouses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }